const CATEGORY_LABELS_ES: Record<string, string> = {
  rent: "Arriendo",
  utilities: "Servicios",
  equipment: "Equipamiento",
  maintenance: "Mantención",
  marketing: "Marketing",
  salaries: "Sueldos",
  credits: "Créditos",
  taxes: "Impuestos",
  other: "Otros",
};

export const CATEGORY_OPTIONS: Array<{ value: string; label: string }> = [
  { value: "rent", label: CATEGORY_LABELS_ES.rent },
  { value: "utilities", label: CATEGORY_LABELS_ES.utilities },
  { value: "equipment", label: CATEGORY_LABELS_ES.equipment },
  { value: "maintenance", label: CATEGORY_LABELS_ES.maintenance },
  { value: "marketing", label: CATEGORY_LABELS_ES.marketing },
  { value: "salaries", label: CATEGORY_LABELS_ES.salaries },
  { value: "credits", label: CATEGORY_LABELS_ES.credits },
  { value: "taxes", label: CATEGORY_LABELS_ES.taxes },
  { value: "other", label: CATEGORY_LABELS_ES.other },
];

export const getCategoryLabel = (category: string): string =>
  CATEGORY_LABELS_ES[category] ?? category.replace(/_/g, " ");
